import React from "react";
import { Outlet } from "react-router";

const BillingReissue = () => {
  return <Outlet />;
};

export default BillingReissue;
